import { Button, Grid, TextField, MenuItem, DialogActions, Box, Typography, IconButton } from '@mui/material';
import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';
import CloseIcon from '@mui/icons-material/Close';
import CustomerService from 'services/CustomerService';
import { AlertMessagesContext } from 'react-alert-messages';
import Loader from 'components/utils/Loading';
import ShopsHelper from 'helpers/ShopsHelper';
import { InventoryContext } from 'Context/InventoryContext';
import { ShopContext } from 'Context/ShopContext';

export default function NewCustomerGroupDialog(props) {
  const { toggleAddTab } = props;
  const { postAlertMessage } = useContext(AlertMessagesContext);
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');
  const { shop } = useContext(ShopContext);
  const { priceCategories } = useContext(InventoryContext);

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [loadingIndicator, setLoadingIndicator] = useState(false);
  const [priceCategory, setPriceCategory] = useState(null);

  const createNewCustomer = async () => {
    const data = {
      name,
      description,
      price_category_id: priceCategory,
    };
    setLoadingIndicator(true);
    try {
      await CustomerService.createCustomerGroup(data);
      postAlertMessage({
        text: tPopup('Customer group created successfully'),
        type: 'success',
      });
      toggleAddTab('Save');
    } catch (error) {
      postAlertMessage({ text: error.message, type: 'failed' });
      toggleAddTab();
    }
    setLoadingIndicator(false);
  };

  return (
    <Box className={styles.popUp}>
      <Box className={styles.contentWrapper}>
        <Loader isOpen={loadingIndicator} />
        <Box className={styles.headSec}>
          <Typography component="h2" className={styles.editTitle}>
            {tCommon('Create New Customer Group')}
          </Typography>
          <IconButton size="small" onClick={toggleAddTab}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box className={styles.inputSec}>
          <Grid container className={styles.inputRow} alignItems="center">
            <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
              <h3 className={styles.inputLabel}>{tCommon('Name')}</h3>
            </Grid>
            <Grid item xs={8} sm={8}>
              <TextField
                label={tCommon('Name')}
                variant="outlined"
                size="small"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid container className={styles.inputRow} alignItems="center">
            <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
              <h3 className={styles.inputLabel}>{tCommon('Description')}</h3>
            </Grid>
            <Grid item xs={8} sm={8}>
              <TextField
                label={tCommon('Description')}
                variant="outlined"
                size="small"
                name="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                fullWidth
                multiline
                rows={2}
              />
            </Grid>
          </Grid>
          {ShopsHelper.hasProAccess(shop) && (
            <Grid container className={styles.inputRow} alignItems="center">
              <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
                <h3 className={styles.inputLabel}>{tCommon('Price Category')}</h3>
              </Grid>
              <Grid item xs={8} sm={8}>
                <TextField
                  select
                  label={tCommon('Price Category')}
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={priceCategory || ''}
                  onChange={(e) => setPriceCategory(e.target.value)}
                >
                  <MenuItem value="">None</MenuItem>
                  {priceCategories?.map((category) => (
                    <MenuItem key={category.id} value={category.id}>
                      {category.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
          )}
        </Box>
        <Box className={styles.footSec}>
          <DialogActions>
            <Button variant="contained" color="secondary" size="small" onClick={toggleAddTab}>
              {tCommon('Close')}
            </Button>
            <Button
              variant="contained"
              size="small"
              color="primary"
              sx={{ backgroundColor: '#00a65a' }}
              disabled={name === '' || loadingIndicator}
              onClick={createNewCustomer}
            >
              {tCommon('Create Group')}
            </Button>
          </DialogActions>
        </Box>
      </Box>
    </Box>
  );
}
